<template>
  <v-dialog
    content-class="annotationInfoDialog"
    :value="value"
    @input="(v) => v || close()"
    hide-overlay
    persistent
    no-click-animation
    transition="fade-transition"
    max-width="330px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">アノテーション編集</span>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container class="pb-0">
          <v-form ref="editAnnotationForm" lazy-validation>
            <v-select
              hide-details="auto"
              v-model="info.type"
              label="異常種類"
              outlined
              dense
              :items="types"
              required
              :rules="[
                (v) => (!!v && !!v.trim()) || '異常種類を選択してください。',
              ]"
              @change="changeType"
              :disabled="!editable"
            ></v-select>
            <v-select
              hide-details="auto"
              v-model="info.reason"
              label="原因"
              outlined
              clearable
              dense
              :items="reasons"
              :disabled="info.type == 'shadow' || !editable"
            ></v-select>
            <h4>座標:</h4>
            <span v-if="info.coordinates"
              >{{ info.coordinates[0] }}, {{ info.coordinates[1] }}</span
            >
          </v-form>
          <v-row class="mt-2">
            <v-col cols="3" v-for="(item, index) in info.thermalImages" :key="item.src" class="image-container" @click="displayImages(index, 'thermal')">
              <v-img
                  lazy-src="@/assets/images/no-image.png"
                  class="image"
                  max-height="100"
                  aspect-ratio="1"
                  :src="item.src">
                <template v-slot:placeholder>
                  <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                  >
                    <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
                <div class="d-flex justify-end" v-if="!Array.isArray(item.crop) || !Array.isArray(item.annotation_mark)">
                  <div style="background: rgba(245,245,245,1); border-radius: 50%;">
                    <v-icon :color="!Array.isArray(item.crop) ? 'primary' : 'deep-orange darken-2'">mdi-checkbox-marked-circle</v-icon>
                  </div>
                </div>
              </v-img>
              <div class="icon">
                <v-icon>
                  mdi-magnify-plus-outline
                </v-icon>
              </div>
            </v-col>
            <v-col cols="3" v-for="(item, index) in info.colorImages" :key="item.src" class="image-container" @click="displayImages(index, 'color')">
              <v-img
                  lazy-src="@/assets/images/no-image.png"
                  class="image"
                  max-height="100"
                  aspect-ratio="1"
                  :src="item.src">
                <template v-slot:placeholder>
                  <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                  >
                    <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
                <div class="d-flex justify-end" v-if="!Array.isArray(item.crop) || !Array.isArray(item.annotation_mark)">
                  <div style="background: rgba(245,245,245,1); border-radius: 50%;">
                    <v-icon :color="!Array.isArray(item.crop) ? 'primary' : 'deep-orange darken-2'">mdi-checkbox-marked-circle</v-icon>
                  </div>
                </div>
              </v-img>
              <div class="icon">
                <v-icon>
                  mdi-magnify-plus-outline
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-btn min-width="60px" depressed @click="onDeleteConfirm()" color="error" v-if="editable">削除</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="close()">キャンセル</v-btn>
        <v-btn depressed @click.native="onEdit()" color="primary" v-if="editable">編集</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {store} from "@/store";

export default {
  name: "AnnotationEditDialog",
  props: ["value", "info"],
  data() {
    return {
      mapviewState: store.state.mapview,
      block: {},
      types: [
        { text: "ホットスポット", value: "cell" },
        { text: "マルチホットスポット", value: "multicell" },
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module" },
        { text: "ストリング異常", value: "string" },
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        { text: "影", value: "shadow" },
      ],
      reasons: [
        { text: "割れ", value: "crack" },
        { text: "堆積物", value: "sediment" },
        { text: "植生", value: "vegetation" },
      ],
    };
  },
  methods: {
    onEdit() {
      if (this.$refs.editAnnotationForm.validate()) {
        this.axios
          .put("/api/annotation/" + this.mapviewState.folderId, this.info)
          .then((response) => {
            store.updateFilterWhenAddOrUpdateAnnotation(this.mapviewState.folderId, this.info);
            this.$emit("edited", response.data);
            this.close();
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
            this.close();
          });
      }
    },
    onDeleteConfirm() {
      const confirmDialog = {
        title: '削除確認',
        content: `選択した異常を削除します。よろしいですか。`,
        onAgree: () => this.delete(),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    delete() {
      const body = {
        data: this.info
      }
      this.axios
        .delete(`/api/annotation/${this.mapviewState.folderId}`, body)
        .then((response) => {
          this.$emit("deleted", response.data);
          this.close();
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
          this.close();
        });
    },
    close() {
      this.$emit("input");
    },
    displayImages(position, imageType){
      if (imageType === 'thermal'){
        this.$emit('displayAnnotationImages', this.info.coordinates, this.info.thermalImages, position, imageType);
      }
      if (imageType === 'color'){
        this.$emit('displayAnnotationImages', this.info.coordinates, this.info.colorImages, position, imageType);
      }
    },
    changeType(){
      if (this.info.type === 'shadow'){
        this.info.reason = null;
      }
    }
  },
  computed: {
    editable() {
      return store.state.currentReportStatus === 'NEW' || store.state.currentReportStatus === 'BRANCH_REQUEST_REJECTED' || store.state.currentReportStatus === 'AREA_REQUEST_REJECTED' || store.state.currentReportStatus === 'SUBMIT_REJECTED'
    }
  }
};
</script>

<style>
.icon{
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image-container{
  position: relative;
  padding: 2px;
}

.image-container:hover .icon{
  opacity: 1;
}

.image-container:hover .image{
  opacity: 0.3;
}
</style>
